<div class="call-us">
    <h1>Give us a call</h1>
    <p>To begin, call this number and enter your PIN:</p>

    <br />
    <cr-avid-phone-and-pin [pin]="pin" [phone]="phone"></cr-avid-phone-and-pin>
</div>
